import { render, staticRenderFns } from "./user_avatar.vue?vue&type=template&id=3f094232&"
import script from "./user_avatar.vue?vue&type=script&lang=js&"
export * from "./user_avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f094232')) {
      api.createRecord('3f094232', component.options)
    } else {
      api.reload('3f094232', component.options)
    }
    module.hot.accept("./user_avatar.vue?vue&type=template&id=3f094232&", function () {
      api.rerender('3f094232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/user/user_avatar.vue"
export default component.exports